import { render, staticRenderFns } from "./ShopView.vue?vue&type=template&id=11e1f4ac&"
import script from "./ShopView.vue?vue&type=script&lang=js&"
export * from "./ShopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports